import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, ValidatorFn, AbstractControl } from '@angular/forms';
import { Router } from '@angular/router';
import { VendorInvoiceFormService } from '../Services/vendor-invoice-form.service';
import { InvoiceSearch } from '../models/invoiceSearch.model';
import { ColDef, GridApi, ColumnApi } from 'ag-grid-community';
import { Observable } from 'rxjs/internal/Observable';
import { OktaAuthService } from '@okta/okta-angular';
import { NgxSpinnerService } from 'ngx-spinner';
@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css']
})

export class SearchComponent implements OnInit {

  public isAuthenticated: boolean;
  popup:boolean;
  invoiceForm: any;
  VendorInvoiceFormService: any;
  formGeneral: FormGroup;
  // formManufacturing: FormGroup;
  // formCertifications: FormGroup;
  // formSourcing: FormGroup;
 
  private api: GridApi;
  private columnApi: ColumnApi;
  VendorNumber: any;
  InvoiceNumber: any;
  formGroup: FormGroup;
  userName: any;
  currentYear: number;
  spinner: any;
  submitted: boolean;
  gridApi: any;
  gridColumnApi: any;
  
  
 

    
  constructor(public oktaAuth: OktaAuthService, private formBuilder: FormBuilder, private vendorInvoice: VendorInvoiceFormService, private router: Router, private SpinnerService : NgxSpinnerService ) {
     
    
    // // get authentication state for immediate use
    // this.oktaAuth.isAuthenticated().then(result => {
    //   this.isAuthenticated = result;
    // });

    // // subscribe to authentication state changes
    // this.oktaAuth.$authenticationState.subscribe(
    //   (isAuthenticated: boolean) => this.isAuthenticated = isAuthenticated
    // );

    this.formGroup = this.formBuilder.group({     
      VendorNumber: ['', Validators.required],
      InvoiceNumber: ['', Validators.required]
    });

  }

  async ngOnInit() {
   
    this.oktaAuth.isAuthenticated().then(result => {
      this.isAuthenticated = result;
      if(!result)
        this.oktaAuth.loginRedirect();
    });

    // subscribe to authentication state changes
    this.oktaAuth.$authenticationState.subscribe(
      (isAuthenticated: boolean) => this.isAuthenticated = isAuthenticated
    );
     // returns an object with user's claims
     const userClaims = await this.oktaAuth.getUser();

     // user name is exposed directly as property
     this.userName = (await userClaims).name;

    
    this.currentYear=new Date().getFullYear();

    this.invoiceForm = this.formBuilder.group({
      "VendorNumber": ["", Validators.required],
      "InvoiceNumber": ["", Validators.required]
    });

  
  }



  columnDefs = [
    { headerName: 'Invoice Number', field: 'invoiceNum', sortable: "true", filter: "true", resizable: true, wrapText: true, autoHeight: true, width: "160px" },
    { headerName: 'Amount', field: 'amount', sortable: "true", filter: "true", resizable: true,width: "150px",wrapText: true, autoHeight: true,  },
    { headerName: 'Currency', field: 'currency', sortable: "true", filter: "true", resizable: true, width: "130px" },
    { headerName: 'Payment reference', field: 'checkNumber', sortable: "true", filter: "true", resizable: true, width: "160px", wrapText: true, autoHeight: true },
    { headerName: 'Scheduled Pay Date', field: 'scheduled', sortable: "true", filter: "true", resizable: true, width: "160px" },
    { headerName: 'Actual Paid Date', field: 'actualPAI', sortable: "true", filter: "true", resizable: true, width: "160px" },
    { headerName: 'Invoice Status', field: 'message', sortable: "true", filter: "true", resizable: true,wrapText: true, autoHeight: true, width: "195px",tooltipField: 'message' }
  ];
  rowData = [
    // {invoicenumber:'207879',amount:'54145',currency:'USD',paymentreference:'6909063',scheduledpaydate:'July 19, 2020',actualpaiddate:'july 20,2021',invoicestatus:'PAID'},
    //{invoicenumber:'207800',amount:'6466',currency:'USD',paymentreference:'756866',scheduledpaydate:'July 19, 2020',actualpaiddate:'july 20,2021',invoicestatus:'PAID'},
    //{invoicenumber:'207895',amount:'86868686',currency:'USD',paymentreference:'773833',scheduledpaydate:'July 19, 2020',actualpaiddate:'july 20,2021',invoicestatus:'PAID'}
  ];
 
  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.sizeColumnsToFit();
    this.gridApi.setDomLayout('print');
  }

  Print() {
    let printData = document.getElementById('myGridPrint').cloneNode(true);
    let logo = document.getElementById('logo').cloneNode(true);
    document.body.appendChild(logo);
    document.body.appendChild(printData);
    document.body.style.alignContent = "top";
    window.print();
    document.body.removeChild(printData);
    document.body.removeChild(logo);

  }

  onSubmit(formData) {
    this.rowData = [];
    var VendorNumber = formData['VendorNumber'];
    var InvoiceNumber = formData['InvoiceNumber'];
    var str = InvoiceNumber;
    var splitted = str.split(","); 
    this.submitted = true;

        if(VendorNumber.trim()!="" && InvoiceNumber.trim()!="")
        {
        if(splitted.length>10)
        {
          alert("Maximum 10 invoices are allowed at a time.");
        }
      else{     
        this.SpinnerService.show();
        this.vendorInvoice.GetInvoiceDetails(VendorNumber, InvoiceNumber).subscribe((data) => {
          if (data == null) {    
            alert("No data found");
          }
          else {
            var DistDataArray = Object.values(data);
            this.rowData = DistDataArray;
          }
          this.SpinnerService.hide();
        });
      }   
    }
   
  }
}


